import * as form from '../form';

const foreignPassport = (data = {}) => ({
  HasPassports: form.branch(data.HasPassports),
  Name: form.name(data.Name),
  Number: form.text(data.Number),
  Card: form.radio(data.Card),
  Issued: form.datecontrol(data.Issued),
  Expiration: form.datecontrol(data.Expiration),
  Comments: form.textarea(data.Comments),
  OptionalComments: form.textarea(data.OptionalComments),
  HasPassportBook: form.branch(data.HasPassportBook), // Item and below PVQ Only
  PassportBooks: form.passports(data.PassportBooks),
  HasPassportBookExplanation: form.textarea(data.HasPassportBookExplanation),
  PassportCard: form.passport(data.PassportCard),
  HasPassportCard: form.branch(data.HasPassportCard),
  HasPassportCardExplanation: form.textarea(data.HasPassportCardExplanation),
});

export default foreignPassport;
